import { render, staticRenderFns } from "./product.vue?vue&type=template&id=cf47de32&scoped=true"
import script from "./product.ts?vue&type=script&lang=ts&external"
export * from "./product.ts?vue&type=script&lang=ts&external"
import style0 from "./product.scoped.scss?vue&type=style&index=0&id=cf47de32&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf47de32",
  null
  
)

export default component.exports